"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmptyString = _interopRequireDefault(require("../object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../object/isNil"));

var HTTP_MAYBE_S_REGEX = /^https?:\/\//i;

var fullyQualifyURL = function fullyQualifyURL(url) {
  if ((0, _isNil["default"])(url) || (0, _isEmptyString["default"])(url)) return null;

  if (HTTP_MAYBE_S_REGEX.test(url)) {
    return url;
  }

  return url.indexOf('/') === 0 ? "".concat(self.location.origin).concat(url) : "".concat(self.location.origin, "/").concat(url);
};

var _default = fullyQualifyURL;
exports["default"] = _default;